import React, { useMemo } from 'react';
import { formatFullDecimal } from 'utils/number';

type ShippingFeeProps = {
  value: number | string;
  symbol?: boolean;
};

export default function ShippingFee(props: ShippingFeeProps) {
  // `symbol` is accepted for call-site compatibility — the R$ prefix is always
  // rendered, as it was before.
  const { value, symbol = false } = props;
  const renderValue = useMemo(() => {
    if (value === 0.0 || Number.isNaN(value)) {
      return '-';
    }
    const valueNumber = typeof value === 'string' ? parseFloat(value) : value;

    // Renders the precision the backend actually sent (up to 6 decimals),
    // without padding trailing zeros.
    return `R$${formatFullDecimal(valueNumber)}`;
  }, [value]);

  return <span>{renderValue}</span>;
}
